<template>
  <div>
    <h2>{{ $t('title.pending-accesses') }}</h2>

    <data-table
        :model="accesses"
        :columns="['mobileName', 'switchName', 'key_type', 'controllerName']"
        :operations="operations" />

    <el-dialog
      :title="$t('title.remove')"
      :visible="!!accessToDelete"
      width="30%"
      :before-close="() => { accessToDelete = null }">
      <span>{{ $t('remove.message') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="accessToDelete = null">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="deleteModel">{{ $t('button.confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import api from 'service/api'
import findAll from 'service/findAll'
import empty from 'empty'

export default {
  name: 'pending-access-list',
  props: {
  },
  data () {
    return {
      defaultAccesses: [],
      accessToDelete: null,
      isScheduled: false,
      operations: [
        {
          label: 'activate-scheduled',
          type: 'success',
          method: access => this.activateAccess(access, true)
        },
        {
          label: 'activate',
          type: 'success',
          method: access => this.activateAccess(access, false)
        },
        {
          label: 'disable-scheduled',
          type: 'warning',
          method: access => this.disableAccess(access, true)
        },
        {
          label: 'disable',
          type: 'warning',
          method: access => this.disableAccess(access, false)
        },
        {
          label: 'delete-scheduled',
          type: 'danger',
          method: access => {
            this.accessToDelete = access
            this.isScheduled = true
          }
        },
        {
          label: 'delete',
          type: 'danger',
          method: access => (this.accessToDelete = access)
        }
      ]
    }
  },
  computed: {
    accesses () {
      return this.defaultAccesses.map(a => {
        const mobile = this.mobiles.find(m => m.id === a.mobile_id) || empty
        a.mobileName = mobile.contact_name

        const xswitch = this.switches.find(s => s.id === a.switch_id) || empty
        a.switchName = xswitch.name
        a.controllerName = xswitch.controllerName

        return a
      })
    }
  },
  async beforeMount () {
    const accesses = await this.getPendingAccesses()
    this.defaultAccesses = accesses
  },
  methods: {
    deleteModel () {
      this.deleteAccess(this.accessToDelete, this.isScheduled)
      this.accessToDelete = null
    }
  },
  components: { },
  mixins: [ api, findAll('switches'), findAll('mobiles'), findAll('controllers') ]
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// PendingAccessList.vue?70d93e7e